import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  Typography,
  Pagination,
  Button,
  Modal,
  TextField
} from "@mui/material";

import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon
} from "@mui/icons-material";

const Medialist = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3001/api/";
  } else {
    xURL = "https://sau.rihes.cmu.ac.th/api/";
  }

  const [mediaData, _mediaData] = useState([]);

  const rowsPerPage = 5;

  const [page, setPage] = useState(1);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const paginatedData = mediaData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const [openModal, setOpenModal] = useState(false);
  const [newData, setNewData] = useState({ name: "", link_y: "" });

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState({ name: "", link_y: "" });

  const [old_name, _old_name] = useState("");

  useEffect(() => {
    Find_media();
  }, []);

  const Find_media = () => {
    axios
      .get(xURL + "find_media_list")
      .then(result => {
        ShowMedia(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const ShowMedia = zdata => {
    const Tb1 = [];

    zdata.forEach((i, idx) => {
      Tb1.push({
        id: idx + 1,
        name: i.name,
        link_y: i.link,
        linkname: i.remark
      });
    });

    _mediaData(Tb1);
  };

  const handleOpenModal = () => {
    setNewData({ name: "", link_y: "" });

    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  const handleAddData = () => {
    // console.log("ชื่อคลิป:", newData.name);
    // console.log("link:", newData.link_y);

    if (!newData.name) {
      Swal.fire({
        title: "บันทึกไม่ได้",
        text: "ยังไม่ได้กรอก ชื่อคลิป",
        icon: "info",
        confirmButtonColor: "#3F51B5",
        willOpen: () => {
          // เพิ่ม z-index ที่สูงกว่า Modal MUI
          const swal = document.querySelector(".swal2-container");
          if (swal) {
            swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
          }
        }
      });
      return;
    }

    if (!newData.link_y) {
      Swal.fire({
        title: "บันทึกไม่ได้",
        text: "ยังไม่ได้กรอก link youtube",
        icon: "info",
        confirmButtonColor: "#3F51B5",
        willOpen: () => {
          // เพิ่ม z-index ที่สูงกว่า Modal MUI
          const swal = document.querySelector(".swal2-container");
          if (swal) {
            swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
          }
        }
      });
      return;
    }

    insertMedia();
  };

  const insertMedia = () => {
    axios
      .post(xURL + "insert_media", {
        name: newData.name,
        link_y: newData.link_y
      })
      .then(result => {
        Swal.fire({
          title: "บันทึกสำเร็จ!",
          text: "ข้อมูลถูกบันทึกเรียบร้อย",
          icon: "success",
          confirmButtonColor: "#3F51B5",
          willOpen: () => {
            // เพิ่ม z-index ที่สูงกว่า Modal MUI
            const swal = document.querySelector(".swal2-container");
            if (swal) {
              swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
            }
          }
        }).then(() => {
          Find_media();

          handleCloseModal();
        });
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const handleEdit = (name, link_y) => {
    _old_name(name);
    setEditData({ name, link_y });
    setEditModalOpen(true);
  };

  const handleUpdateData = () => {
    // console.log("ชื่อเรื่อง:", editData.name);
    // console.log("cmutolink:", editData.link_y);

    if (!editData.name) {
      Swal.fire({
        title: "ไม่สามารถบันทึกได้",
        text: "ชื่อคลิปว่าง",
        icon: "warning",
        confirmButtonColor: "#3F51B5",
        willOpen: () => {
          // เพิ่ม z-index ที่สูงกว่า Modal MUI
          const swal = document.querySelector(".swal2-container");
          if (swal) {
            swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
          }
        }
      });
      return;
    }

    if (!editData.link_y) {
      Swal.fire({
        title: "ไม่สามารถบันทึกได้",
        text: "link youtube ว่าง",
        icon: "warning",
        confirmButtonColor: "#3F51B5",
        willOpen: () => {
          // เพิ่ม z-index ที่สูงกว่า Modal MUI
          const swal = document.querySelector(".swal2-container");
          if (swal) {
            swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
          }
        }
      });
      return;
    }

    axios
      .post(xURL + "update_media", {
        name: editData.name,
        link_y: editData.link_y,
        old_name: old_name
      })
      .then(res => {
        Swal.fire({
          title: "อัปเดตสำเร็จ!",
          text: "ข้อมูลถูกแก้ไขแล้ว",
          icon: "success",
          confirmButtonColor: "#3F51B5",
          willOpen: () => {
            // เพิ่ม z-index ที่สูงกว่า Modal MUI
            const swal = document.querySelector(".swal2-container");
            if (swal) {
              swal.style.zIndex = 1500; // หรือมากกว่า z-index ของ Modal
            }
          }
        }).then(() => {
          Find_media();
          setEditModalOpen(false);
        });
      })
      .catch(error => {
        console.log("update error:", error);
      });
  };

  const handleDelete = (name, link_y) => {
    Swal.fire({
      title: "ยืนยัน ลบข้อมูล",
      text: "เรื่อง " + name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก"
    }).then(result => {
      if (result.isConfirmed) {
        axios
          .post(xURL + "delete_media", {
            name: name,
            link_y: link_y
          })
          .then(result => {
            Swal.fire({
              title: "ลบสำเร็จ!",
              text: "ข้อมูลถูกลบเรียบร้อย",
              icon: "success",
              confirmButtonColor: "#3F51B5"
            }).then(() => {
              Find_media();
            });
          })
          .catch(function(error) {
            // handle error
            console.log("problem here", error);
          });
      }
    });
  };

  return (
    <React.Fragment>
      {/* ปุ่มเพิ่มข้อมูล */}
      <Box sx={{ textAlign: "left" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{ mb: 1 }}
        >
          เพิ่มข้อมูล
        </Button>
      </Box>

      {/* Modal สำหรับเพิ่มข้อมูล */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 2
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            เพิ่มข้อมูลใหม่
          </Typography>

          {/* ฟอร์มกรอกชื่อเรื่อง */}
          <TextField
            fullWidth
            label="ชื่อคลิป"
            variant="outlined"
            sx={{ mb: 2 }}
            value={newData.name}
            onChange={e => setNewData({ ...newData, name: e.target.value })}
          />

          {/* ฟอร์มกรอกชื่อ link */}
          <TextField
            fullWidth
            label="link youtube"
            variant="outlined"
            sx={{ mb: 2 }}
            value={newData.link_y}
            onChange={e => setNewData({ ...newData, link_y: e.target.value })}
          />

          {/* ปุ่มบันทึกข้อมูล */}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleAddData}
          >
            บันทึกข้อมูล
          </Button>
        </Box>
      </Modal>

      {/* Modal สำหรับแก้ไขข้อมูล */}
      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 2
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            แก้ไขข้อมูล
          </Typography>

          <TextField
            fullWidth
            label="ชื่อคลิป"
            variant="outlined"
            sx={{ mb: 2 }}
            value={editData.name}
            onChange={e => setEditData({ ...editData, name: e.target.value })}
          />
          <TextField
            fullWidth
            label="link youtube"
            variant="outlined"
            sx={{ mb: 2 }}
            value={editData.link_y}
            onChange={e => setEditData({ ...editData, link_y: e.target.value })}
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleUpdateData}
          >
            แก้ไข
          </Button>
        </Box>
      </Modal>

      <Box>
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "bold", textAlign: "center" }}
        >
          รายการคลิป
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ borderRadius: 2, boxShadow: 3 }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: "#3F51B5" }}>
              <TableRow>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                  #
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                  ชื่อคลิป
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                  link youtube
                </TableCell>
                <TableCell
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center"
                  }}
                >
                  จัดการ
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map(row =>
                <TableRow key={row.id} sx={{ height: "50px" }}>
                  <TableCell>
                    {row.id}
                  </TableCell>
                  <TableCell>
                    {row.name}
                  </TableCell>
                  <TableCell>
                    {row.link_y}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <IconButton
                      color="warning"
                      onClick={() => handleEdit(row.name, row.link_y)}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(row.name, row.link_y)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.ceil(mediaData.length / rowsPerPage)}
            page={page}
            onChange={handleChangePage}
            color="primary"
          />
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Medialist;
